export default __webpack_public_path__ + "static/media/poster.81a3cbd9.png";